module.exports = __webpack_public_path__ + "img/inclusive-gateway.c5f0f855.svg";